import { ref, computed } from 'vue'

/**
 * 普通车
 */
const NORMAL = 'normal'

/**
 * 新能源车
 */
const NEW_ENERGY = 'newEnergy'

/**
 * 省份
 */
const PROVINCES = 'provinces'

/**
 * 字母
 */
const LETTERS = 'letters'

/**
 * 普通车牌号码长度
 */
const NORMAL_LENGTH = 7

/**
 * 新能源车牌号码长度
 */
const NEW_ENERGY_LENGTH = 8

/**
 * 是否显示键盘
 */
const isShowKeyboard = ref(false)

/**
 * 车牌号码
 */
const plateNumber = ref('')

/**
 * 车牌号码输入模式
 * normal: 普通车
 * newEnergy: 新能源车
 */
const plateNumberInputMode = ref(NORMAL)

/**
 * 车牌限制的长度
 */
const plateNumberLimitLength = computed(() => {
  return plateNumberInputMode.value === NORMAL
    ? NORMAL_LENGTH
    : NEW_ENERGY_LENGTH
})

/**
 * 是否输入完成
 */
const isInputComplete = computed(() => {
  return plateNumber.value.length === plateNumberLimitLength.value
})

/**
 * 键盘输入模式
 * provinces: 省份
 * letters: 字母
 */
const keyboardInputMode = ref(PROVINCES)

const provinces = [
  '京',
  '津',
  '冀',
  '晋',
  '蒙',
  '辽',
  '吉',
  '黑',
  '沪',
  '苏',
  '浙',
  '皖',
  '闽',
  '赣',
  '鲁',
  '豫',
  '鄂',
  '湘',
  '粤',
  '桂',
  '琼',
  '渝',
  '川',
  '云',
  '贵',
  '藏',
  '陕',
  '甘',
  '青',
  '宁',
  '新'
]

const letters = [
  '1',
  '2',
  '3',
  '4',
  '5',
  '6',
  '7',
  '8',
  '9',
  '0',
  'Q',
  'W',
  'E',
  'R',
  'T',
  'Y',
  'U',
  // 'I',
  // 'O',
  'P',
  'A',
  'S',
  'D',
  'F',
  'G',
  'H',
  'J',
  'K',
  'L',
  'Z',
  'X',
  'C',
  'V',
  'B',
  'N',
  'M'
]

export default function usePlateKeyboard() {
  /**
   * 设置键盘输入模式
   */
  const setKeyboardInputMode = (mode) => {
    keyboardInputMode.value = mode
  }

  /**
   * 显示键盘
   */
  const showKeyboard = () => {
    isShowKeyboard.value = true
  }

  /**
   * 隐藏键盘
   */
  const hideKeyboard = () => {
    isShowKeyboard.value = false
  }

  /**
   * 车牌号码退格
   */
  const removePlateNumber = () => {
    plateNumber.value = plateNumber.value.slice(0, -1)
  }

  /**
   * 车牌号码清空
   */
  const clearPlateNumber = () => {
    plateNumber.value = ''
  }

  /**
   * 车牌号码输入
   */
  const inputPlateNumber = (value) => {
    if (plateNumber.value.length < plateNumberLimitLength.value) {
      plateNumber.value += value
    }
  }

  /**
   * 车牌号码输入模式切换
   */
  const togglePlateNumberInputMode = () => {
    plateNumberInputMode.value =
      plateNumberInputMode.value === NORMAL ? NEW_ENERGY : NORMAL
    plateNumber.value = ''
  }

  /**
   * 根据mode切换车牌号码输入模式
   */
  const setPlateNumberInputMode = (mode) => {
    // 清空车牌号码
    clearPlateNumber()
    plateNumberInputMode.value = mode
  }

  /**
   * 键盘的keys
   */
  const keys = computed(() => {
    return keyboardInputMode.value === PROVINCES ? provinces : letters
  })

  return {
    NORMAL,
    NEW_ENERGY,
    PROVINCES,
    LETTERS,
    isShowKeyboard,
    plateNumber,
    plateNumberInputMode,
    isInputComplete,
    plateNumberLimitLength,
    keyboardInputMode,
    setKeyboardInputMode,
    showKeyboard,
    hideKeyboard,
    removePlateNumber,
    clearPlateNumber,
    inputPlateNumber,
    togglePlateNumberInputMode,
    setPlateNumberInputMode,
    keys
  }
}
